export const SUBMIT_CODE_SUCCESSFUL = "submit_code_successful";
export const SUBMIT_CODE_FAILED = "submit_code_failed";
